import React, { useEffect, useState } from 'react';
import LenderManagement from '../components/LenderManagement';
import { AdminLenderPreCheck } from '../components/AdminLenderPreCheck';
import LenderSuggestions from '../components/LenderSuggestions';
import UnknownLenders from '../components/UnknownLenders';
import './LenderHub.css';

const tabs = [
  { id: 'canonicals', label: 'Canonicals' },
  { id: 'suggestions', label: 'Suggestions' },
  { id: 'unknowns', label: 'Unknowns' },
  { id: 'tools', label: 'Tools' },
];

const LenderHub: React.FC = () => {
  const [active, setActive] = useState('canonicals');
  const [canonicalsRefreshKey, setCanonicalsRefreshKey] = useState(0);

  useEffect(() => {
    // Trigger initial load for canonicals when the hub mounts
    setCanonicalsRefreshKey(prev => prev + 1);
  }, []);

  const handleTabChange = (tabId: string) => {
    setActive(tabId);
    if (tabId === 'canonicals') {
      setCanonicalsRefreshKey(prev => prev + 1);
    }
  };

  const renderActiveTab = () => {
    switch (active) {
      case 'canonicals':
        return <LenderManagement refreshKey={canonicalsRefreshKey} />;
      case 'suggestions':
        return <LenderSuggestions />;
      case 'unknowns':
        return <UnknownLenders />;
      case 'tools':
        return <AdminLenderPreCheck />;
      default:
        return null;
    }
  };

  return (
    <div className="lender-hub">
      <h2>Lender Hub</h2>
      <div className="tab-bar">
        {tabs.map(t => (
          <button
            key={t.id}
            className={`tab-btn ${active === t.id ? 'active' : ''}`}
            onClick={() => handleTabChange(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {renderActiveTab()}
      </div>
    </div>
  );
};

export default LenderHub; 
